import { openDialog, prepareDialog } from './_dialog.js';

export function initModalWindow() {
  document.querySelectorAll('dialog.c-dialog__modal').forEach(prepareDialog);
  document.querySelectorAll('.c-button__modal').forEach((button) => {
    if (button.dataset.modalInitialized) return;
    button.dataset.modalInitialized = 'true';
    button.addEventListener('click', (event) => {
      event.preventDefault();
      const selector = button.dataset.dialog;
      if (!selector) return;
      try {
        openDialog(document.querySelector(selector), button);
      } catch (error) {
        console.error('モーダルの指定を確認してください。', error);
      }
    });
  });
}
